import { css } from 'emotion';

import { colors, icons } from '@cobliteam/base-components/src/styles';

// ChecklistItemDropdownMenu
export const dropdownMenu = css`
  > li {
    svg {
      padding: 8px;
      background-color: ${colors.gray.lightest};
      border-radius: 5px;
      box-sizing: content-box;
    }

    :hover {
      svg {
        background-color: ${colors.gray.light};
        transition: background-color 0.4s ease-in-out;
      }
    }
  }
`;

export const dropdownMenuButton = (isOpen: boolean) => css`
  > button {
    height: 100%;
    min-width: 0;
    padding: 0;
    border-radius: 3px;
    color: ${colors.gray.default};
    background-color: ${isOpen ? colors.gray.light : colors.gray.lightest};

    svg {
      height: ${icons.size.large};
      width: ${icons.size.large};

      :first-of-type {
        height: ${icons.size.small};
        width: ${icons.size.small};
        padding: 5px;
        box-sizing: content-box;
        color: ${colors.gray.dark};
      }
    }

    :hover {
      background-color: ${colors.gray.light};

      svg {
        color: ${colors.gray.default};

        :first-of-type {
          color: ${colors.gray.dark};
        }
      }
    }
  }
`;

export const newChecklistItem = css`
  > button {
    color: ${colors.primary.hover};
    background-color: ${colors.gray.lightest};
  }
`;

// ChecklistItem
export const checklistItem = css`
  display: flex;
  width: 100%;
`;

export const checklistItemContent = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: 10px;
`;

export const checklistItemHeader = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 26px;
  margin-bottom: 20px;
`;

export const checklistItemError = css`
  margin-top: 5px;
`;

// ChecklistItemOptions
export const checklistItemOptions = css`
  margin-left: 40px;
`;

export const checklistOption = css`
  margin-top: 5px;
`;

export const addChecklistOptionButton = css`
  margin-top: 15px;

  > button {
    color: ${colors.gray.dark};

    :hover {
      color: ${colors.gray.dark};
    }
  }
`;

// ChecklistItemOption
export const checklistItemOption = css`
  display: flex;
  flex-direction: column;
`;

export const checklistItemOptionInput = css`
  display: flex;
  align-items: center;
  width: 100%;

  > button {
    margin-left: 10px;

    svg {
      height: ${icons.size.small};
      width: ${icons.size.small};
    }
  }
`;

export const inputErrorMessage = css`
  margin-top: 5px;
`;
